export default "__VITE_ASSET__CXyNjNNW__"